// document.addEventListener('DOMContentLoaded', function () {
//   const container = document.getElementById('kant-swatch-container');
//   const legend = container.closest('.swatch--gl').querySelector('.name-option');
//   if (!container || !legend) return false;
//   container.addEventListener('change', function (e) {
//     if (e.target.name === 'kant-option') {
//       const selectedLi = e.target.closest('li');
//       const selectedName = selectedLi.querySelector('.gcw-detail-txt--variant-name').textContent.trim();
//       legend.textContent = "Kanttype: " + selectedName;
//     }
//   });
// });

/* ===== Exposing option price and name ===== */
document.addEventListener('DOMContentLoaded', function () {
  // Pre-select options
  // document.querySelector('[name="kant-option"]')?.click();
  // document.querySelector('li.meta-option')?.classList.add('active');
  // document.querySelector('ul.g-variant-color-detail > li.available input')?.click();

  const container = document.getElementById('kant-swatch-container');
  if (!container) return;

  const legend = document.querySelector('.meta-option-title');
  if (!legend) return;

  // Global access
  window.selectedKantPrice = 0;
  window.selectedKantType  = null;

  function updateSelection(input) {
    const li = input.closest('.meta-option');
    if (!li) return;

    const nameEl  = li.querySelector('.meta-option-name');
    const priceEl = li.querySelector('.meta-option-price');
    const name  = nameEl ? nameEl.textContent.trim() : '';
    const price = parseFloat(input.dataset.price || 0);

    // Update legend
    legend.textContent = "Kanttype: " + name;

    // Store globally
    window.selectedKantPrice = price;
    window.selectedKantType  = name;

    // Dispatch event for your app
    window.dispatchEvent(new CustomEvent('kantChanged', {
      detail: {
        name: name,
        price: price
      }
    }));

    // Optional: active class handling
    container.querySelectorAll('.meta-option').forEach(el => {
      el.classList.remove('active');
    });
    li.classList.add('active');
    document.querySelector('.kanttype-error')?.remove();
  }

  // Listen for radio change
  container.addEventListener('change', function (e) {
    if (e.target.name === 'kant-option') {
      updateSelection(e.target);
    }
  });

  // Initialize if preselected
  const checked = container.querySelector('input[name="kant-option"]:checked');
  if (checked) {
    updateSelection(checked);
  }

});

/* ===== Example: Your App Listener ===== */
window.addEventListener('kantChanged', function (e) {
  // console.log("Selected Kant:", e.detail.name);
  // console.log("Selected Price:", e.detail.price);
});

/* ===== Add to cart event prevent when options not selected ===== */
// document.addEventListener('DOMContentLoaded', function () {

//   const addToCartBtn = document.querySelector('.eo-sh-addToCart');
//   const container    = document.getElementById('kant-swatch-container');
//   const errorEl      = document.querySelector('.kanttype-error');

//   if (!addToCartBtn || !container) return;

//   addToCartBtn.addEventListener('click', function (e) {
//     const activeOption = container.querySelector('.meta-option.active');
//     if (!activeOption) {
//       e.preventDefault(); // stop add to cart
//       if (errorEl) {
//         errorEl.textContent = 'Du må gjøre et valg';
//       }
//       return;
//     }
//   });
// });